module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/1-eb35493ec58b9ca8dcae583602f64127.png";